import { render, staticRenderFns } from "./ItemShowActions.vue?vue&type=template&id=57f02e86"
import script from "./ItemShowActions.vue?vue&type=script&lang=js"
export * from "./ItemShowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports